import React from "react";

export default props => (
  <div>
    <h4>{props.title}</h4>
    {props.children}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/theme/tour/tour-content.jsx